function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3088 0.21967C10.0159 -0.0732233 9.54105 -0.0732233 9.24816 0.21967L7.15526 2.31258L3.08116 6.38667C2.94051 6.52733 2.86149 6.71809 2.86149 6.917L2.86149 9.38381C2.86149 9.79802 3.19727 10.1338 3.61149 10.1338H6.07829C6.2772 10.1338 6.46797 10.0548 6.60862 9.91413L10.6827 5.84004L12.7756 3.74713C13.0685 3.45424 13.0685 2.97936 12.7756 2.68647L10.3088 0.21967ZM8.74625 2.84291L9.77849 1.81066L11.1846 3.2168L10.1524 4.24905L8.74625 2.84291ZM7.68559 3.90357L9.09173 5.30971L5.76763 8.63381L4.36149 8.6338L4.36149 7.22766L7.68559 3.90357ZM1.21484 12.5007C0.80063 12.5007 0.464844 12.8365 0.464844 13.2507C0.464844 13.6649 0.80063 14.0007 1.21484 14.0007H14.5877C15.002 14.0007 15.3377 13.6649 15.3377 13.2507C15.3377 12.8365 15.002 12.5007 14.5877 12.5007H1.21484Z",
  fill: "#4290F3"
});

function SvgEditBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBtn);
export default __webpack_public_path__ + "static/media/edit_btn.097937b5.svg";
export { ForwardRef as ReactComponent };